import { Component, OnInit, Input, ViewChild, OnChanges } from '@angular/core';
import { TreeNode } from 'primeng/api';
import { LevantamientoSeleccionadoDTO } from 'src/app/models/dtos/levantamiento-seleccionado-dto';
import { CapaSegmentosDTO } from 'src/app/models/dtos/capa-segmentos-dto';
import { Segmento } from 'src/app/models/entities/segmento';
import { DateUtils } from 'src/app/shared/utils/date-utils';
import { Coordenada } from 'src/app/models/entities/coordenada';
import { ArchivoCoordenada } from 'src/app/models/entities/archivo-coordenada';
import { NgbModalRef, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { LoaderService } from 'src/app/services/loader.service';
import { AlertasService } from 'src/app/services/alertas.service';
import { CapaService } from 'src/app/services/capa.service';
import { SegmentoService } from 'src/app/services/segmento.service';
import { ArchivoCoordenadaService } from 'src/app/services/archivo-coordenada.service';
import { Capa } from 'src/app/models/entities/capa';
import { AngularFireStorage } from '@angular/fire/storage';
import { take, concatMap, map, toArray } from 'rxjs/operators';
import { from } from 'rxjs';
import { ElementoCatalogo } from 'src/app/models/entities/elemento-catalogo';
import { RutaCatalogoEnum } from 'src/app/shared/enums/ruta-catalogo.enum';
import { Estado } from 'src/app/models/entities/estado';
import { CatalogoService } from 'src/app/services/catalogo.service';
import { LevantamientoAvanceService } from 'src/app/services/levantamiento-avance.service';

@Component({
  selector: 'administrar-avances',
  templateUrl: './administrar-avances.component.html',
  styleUrls: ['./administrar-avances.component.scss']
})
export class AdministrarAvancesComponent implements OnInit, OnChanges {


  @ViewChild('modalEliminacionCapa')
  public modalEliminacionCapa: any;

  @ViewChild('modalEliminacionSegmento')
  public modalEliminacionSegmento: any;

  @ViewChild('modalEliminacionArchivo')
  public modalEliminacionArchivo: any;

  @ViewChild('modalEdicionArchivo')
  public modalEdicionArchivo: any;

  public refModalActivo: NgbModalRef;

  @Input('datosObra')
  public datosObra: LevantamientoSeleccionadoDTO;
  public datos: TreeNode[];
  public nodoSeleccionado: TreeNode;


  public readonly CAPA_PROYECTO_PROCESO: string = '0';
  public readonly CAPA_PROYECTO_PLANEACION: string = '4';
  public readonly CAPA_META_ACTUAL: string = '1';
  public readonly CAPA_COMPLETADO: string = '2';
  public readonly CAPA_ESTRUCTURA: string = '5';

  public catEstados: Estado[];
  public catDireccionesAdjuntas: ElementoCatalogo[];
  public catTipoObra: ElementoCatalogo[];
  public catTipoLevantamiento: ElementoCatalogo[];
  public catCapas: ElementoCatalogo[];
  public catColores: ElementoCatalogo[];

  constructor(
    private levantamientoAvanceService: LevantamientoAvanceService,
    private catalogoService: CatalogoService,
    private storage: AngularFireStorage,
    private ngbModalService: NgbModal,
    private dateUtils: DateUtils,
    private loaderService: LoaderService,
    private alertasService: AlertasService,
    private capaService: CapaService,
    private segmentoService: SegmentoService,
    private archivoCoordenadaService: ArchivoCoordenadaService
  ) { }

  async ngOnInit() {
    await this.cargarCatalogos();
    this.crearObjetoArbol();
  }

  ngOnChanges(): void {
    this.crearObjetoArbol();
  }


  public async cargarCatalogos(): Promise<void> {
    this.catEstados = await this.catalogoService.obtenerCatalogo<Estado>(RutaCatalogoEnum.ESTADOS).pipe(take(1)).toPromise();
    this.catDireccionesAdjuntas = await this.catalogoService.obtenerCatalogo<ElementoCatalogo>(RutaCatalogoEnum.DIRECCIONES_ADJUNTAS).pipe(take(1)).toPromise();
    this.catTipoObra = await this.catalogoService.obtenerCatalogo<ElementoCatalogo>(RutaCatalogoEnum.TIPOS_OBRAS).pipe(take(1)).toPromise();
    this.catTipoLevantamiento = await this.catalogoService.obtenerCatalogo<ElementoCatalogo>(RutaCatalogoEnum.TIPOS_LEVANTAMIENTOS).pipe(take(1)).toPromise();
    this.catColores = await this.catalogoService.obtenerCatalogo<ElementoCatalogo>(RutaCatalogoEnum.COLORES).pipe(take(1)).toPromise();
    this.catCapas = await this.catalogoService.obtenerCatalogo<ElementoCatalogo>(RutaCatalogoEnum.CAPAS).pipe(take(1)).toPromise();
  }

  public crearObjetoArbol(): void {
    this.datos = this.datosObra.capasSegmentos.map((capaSegmentos: CapaSegmentosDTO) => ({
      label: capaSegmentos.nombreCapa,
      data: capaSegmentos,
      children: capaSegmentos.segmentos.map((segmento: Segmento) => ({
        label: segmento.fechaRegistro ? this.dateUtils.obtenerFechaConFormato(segmento.fechaRegistro) : this.dateUtils.obtenerFechaConFormato(segmento.fechaCreacion),
        data: segmento,
        children: segmento.coordenadas.filter((coordenada: Coordenada) => coordenada.archivos.length > 0).reduce((prev, curr) => [...prev, ...curr.archivos], []).map((archivo: ArchivoCoordenada) => ({
          label: archivo.nombre,
          data: archivo
        }) as TreeNode)
      }) as TreeNode)
    }) as TreeNode)
  }


  public abrirModalEliminacionCapa() {
    this.refModalActivo = this.ngbModalService.open(this.modalEliminacionCapa, {
      centered: true,
      windowClass: 'modal-confirmacion',
      backdrop: 'static',
      keyboard: false
    });
  }

  public abrirModalEliminacionSegmento() {
    this.refModalActivo = this.ngbModalService.open(this.modalEliminacionSegmento, {
      centered: true,
      windowClass: 'modal-confirmacion',
      backdrop: 'static',
      keyboard: false
    });
  }

  public abrirModalEliminacionArchivo() {
    this.refModalActivo = this.ngbModalService.open(this.modalEliminacionArchivo, {
      centered: true,
      windowClass: 'modal-confirmacion',
      backdrop: 'static',
      keyboard: false
    });
  }

  public async eliminarCapa() {
    this.loaderService.activarLoaderScreen();
    try {
      await this.capaService.delete((this.nodoSeleccionado.data.capa as Capa).key);
      let segmentos: Segmento[] = this.nodoSeleccionado.data.segmentos as Segmento[];
      for (let indiceSegmento = 0; indiceSegmento < segmentos.length; indiceSegmento++) {
        await this.segmentoService.delete(segmentos[indiceSegmento].key);
        let archivosDelSegmento: ArchivoCoordenada[] = segmentos[indiceSegmento].coordenadas.filter((coordenada: Coordenada) => coordenada.archivos.length > 0).reduce((prev, curr) => [...prev, ...curr.archivos], []);
        for (let indiceArchivo = 0; indiceArchivo < archivosDelSegmento.length; indiceArchivo++) {
          await this.archivoCoordenadaService.delete(archivosDelSegmento[indiceArchivo].key);
          await this.storage.storage.refFromURL(archivosDelSegmento[indiceArchivo].urlDescarga).delete();
        }
      }
      this.alertasService.mostrarAlerta('success', 'Se eliminó la capa con éxito.');
      this.nodoSeleccionado = null;
      await this.levantamientoAvanceService.actualizarObra(this.datosObra);
    } catch (err) {
      console.error("Ocurrió un error al intentar eliminar la capa.", err);
      this.alertasService.mostrarAlerta('error', 'Ocurrió un error al intentar eliminar la capa.', err);
    } finally {
      this.refModalActivo.close();
      this.loaderService.desactivarLoaderScreen();
    }
  }

  public async eliminarSegmento() {
    this.loaderService.activarLoaderScreen();
    try {
      await this.segmentoService.delete((this.nodoSeleccionado.data as Segmento).key);
      let archivosDelSegmento: ArchivoCoordenada[] = (this.nodoSeleccionado.data as Segmento).coordenadas.filter((coordenada: Coordenada) => coordenada.archivos.length > 0).reduce((prev, curr) => [...prev, ...curr.archivos], []);
      for (let indice = 0; indice < archivosDelSegmento.length; indice++) {
        await this.archivoCoordenadaService.delete(archivosDelSegmento[indice].key);
        await this.storage.storage.refFromURL(archivosDelSegmento[indice].urlDescarga).delete();
      }
      this.alertasService.mostrarAlerta('success', 'Se eliminó el segmento con éxito.');
      this.nodoSeleccionado = null;
      await this.levantamientoAvanceService.actualizarObra(this.datosObra);
    } catch (err) {
      console.error("Ocurrió un error al intentar eliminar el segmento.", err);
      this.alertasService.mostrarAlerta('error', 'Ocurrió un error al intentar eliminar el segmento.', err);
    } finally {
      this.refModalActivo.close();
      this.loaderService.desactivarLoaderScreen();
    }
  }

  public async eliminarArchivo() {
    this.loaderService.activarLoaderScreen();
    try {
      await this.archivoCoordenadaService.delete((this.nodoSeleccionado.data as ArchivoCoordenada).key);
      await this.storage.storage.refFromURL((this.nodoSeleccionado.data as ArchivoCoordenada).urlDescarga).delete();
      this.alertasService.mostrarAlerta('success', 'Se eliminó el archivo con éxito.');
      this.nodoSeleccionado = null;
      await this.levantamientoAvanceService.actualizarObra(this.datosObra);
    } catch (err) {
      console.error("Ocurrió un error al intentar eliminar el archivo.", err);
      this.alertasService.mostrarAlerta('error', 'Ocurrió un error al intentar eliminar el archivo.', err);
    } finally {
      this.refModalActivo.close();
      this.loaderService.desactivarLoaderScreen();
    }
  }

  eliminarArchivoDeDatosObra(archivoCoordenada: ArchivoCoordenada) {
    let capaSegmentos: CapaSegmentosDTO = this.datosObra.capasSegmentos.find((capaSegmentos: CapaSegmentosDTO) => capaSegmentos.capa.key === archivoCoordenada.keyCapa);
    let segmento: Segmento = capaSegmentos.segmentos.find((segmento: Segmento) => segmento.key === archivoCoordenada.keySegmento);
    let indiceArchivoCoordenada: number = segmento.coordenadas[parseInt(archivoCoordenada.keyCoordenada)].archivos.findIndex((archivo: ArchivoCoordenada) => archivo.key === archivoCoordenada.key);
    segmento.coordenadas[parseInt(archivoCoordenada.keyCoordenada)].archivos.splice(indiceArchivoCoordenada, 1);
  }

  public editarArchivo() {

  }

}
